import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../images/logo.png'
import { useSelector } from 'react-redux'
import { VscGithub } from 'react-icons/vsc'
import { TiSocialLinkedin } from 'react-icons/ti'

export default function Footer() {
    const colo = useSelector((state) => state.theme)

    let year = new Date().getFullYear();

    return (

        <>



            <div className={`${colo.theme} p-4  bg-yakam border-t-[1px] border-chwaram flex flex-row-reverse flex-wrap  justify-evenly `}>

                <div className='w-full lg:w-1/5'>
                    <div className="mb-6 md:mb-0 flex flex-col">
                        <Link to="/home" className="flex justify-center mx-auto items-center">
                            <span className="self-center text-4xl font-semibold whitespace-nowrap text-chwaram">Peshbini</span>
                            <img src={Logo} className="mr-3 h-24  " alt="Logo" />
                        </Link>
                        <p className='text-seyam text-center'>ڕۆژانە پێشبینی بکەو ببەرە خاوەنی خەڵات</p>
                    </div>
                </div>
                <div className='p-2 md:w-1/5  w-1/2'>
                    <h3 className="tracking-wide uppercase text-chwaram text-xl p-2 text-center ">پەڕەکان</h3>
                    <ul className="space-y-1 text-seyam text-center">
                        <li>
                            <Link className='hover:text-chwaram' to="/home">سەرەکی</Link>
                        </li>
                        <li>
                            <Link className='hover:text-chwaram' to="/peshbinikrdn">پێشبینیکردن</Link>
                        </li>
                        <li>
                            <Link className='hover:text-chwaram' to="/games">یاریەکان</Link>
                        </li>
                        <li>
                            <Link className='hover:text-chwaram' to="/nmra">خاڵەکان</Link>
                        </li>
                        <li>
                            <Link className='hover:text-chwaram' to="/sport">کاڵاوەرزشیەکان</Link>
                        </li>
                    </ul>
                </div>
                <div className='p-2 md:w-1/5  w-1/2'>
                    <h3 className="tracking-wide uppercase text-chwaram text-xl p-2 text-center ">یارمەتی</h3>
                    <ul className="space-y-1 text-seyam text-center">
                        <li>
                            <Link className='hover:text-chwaram' to="/info">ڕێنمای</Link>
                        </li>
                        <li>
                            <p className='hover:text-chwaram cursor-pointer'>دەربارەی ئێمە</p>
                        </li>
                    </ul>
                </div>

                <div className='p-2 md:w-1/5 w-1/2 '>
                    <div className='space-y-3'>
                        <div>

                            <h3 className="tracking-wide uppercase text-chwaram text-xl p-2 text-center ">سۆشیاڵ میدیاکانمان</h3>
                            <div className='flex flex-row justify-center space-x-3'>
                                <a href='https://www.facebook.com/bakhtyar.mhamad.5/' className="text-seyam hover:text-chwaram">
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd"></path></svg>
                                    <span className="sr-only">Facebook page</span>
                                </a>
                                <a href='https://www.linkedin.com/in/bakhtyar-m-3a4472234/' className="text-seyam hover:text-chwaram">
                                    <TiSocialLinkedin className='w-5 h-5' />
                                    <span className="sr-only">Linkedin page</span>
                                </a>
                                <a href='https://twitter.com/Bakhtyar__' className="text-seyam hover:text-chwaram">
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path></svg>
                                    <span className="sr-only">Twitter page</span>
                                </a>
                                <a href="https://github.com/Bakhtyar25" className="text-seyam hover:text-chwaram">
                                    <VscGithub className="w-5 h-5" />
                                    <span className="sr-only">GitHub</span>
                                </a>

                            </div>
                        </div>

                        <div className=''>
                            <h3 className="tracking-wide uppercase text-chwaram text-xl p-2 text-center ">پەیوەندی</h3>
                            <div className='flex flex-col justify-center items-center space-x-3'>
                                <p className='text-seyam  hover:text-chwaram cursor-pointer'>0770 000 0000</p>
                                <a href="mailto:info@fmail.com" className="text-center text-seyam  hover:text-chwaram cursor-pointer">
                                    peshbin@gmail.com
                                </a>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className={`${colo.theme} p-4  bg-yakam border-t-[1px] border-chwaram `}>


                <div className="sm:flex sm:items-center sm:justify-evenly  sm:space-x-12 mx-auto">

                    <span className="text-sm text-chwaram flex justify-center  sm:text-center ">
                        {year} PESHBINI™. All Rights Reserved.
                        <span className="text-sm mx-2 text-chwaram flex justify-center  sm:text-center ">
                            Developed by <a href="https://www.facebook.com/bakhtyar.mhamad.5/" className="hover:text-chwaram text-seyam mx-1"> Bakhtyar</a>
                        </span>
                    </span>

                </div>
            </div>
        </>


    )
}
